var _defs, _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRealmLogoNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#793988;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#radial-gradient);}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 469.35,
    y1: 311.52,
    x2: 427.62,
    y2: 945.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#87ff2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#0054a5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 499.74,
    cy: 537.78,
    r: 476.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0082c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0054a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262261"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M813.05,673.86s163.16,240,112.57,393.34L719,775.49Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 719.03,
    y1: 870.53,
    x2: 1099.96,
    y2: 870.53,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.86,924.81a87.08,87.08,0,0,1-24.27-7.95A55.81,55.81,0,0,0,230.86,924.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.42,925c-.84,0-1.7-.11-2.56-.19,31.6,5.55,60-5.77,60-5.77v0C272,923.3,252.77,925.65,233.42,925Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M206.59,916.86c-9.44-6-15.77-14.94-13.11-26.34,1.28-5.47,4.58-10,7.8-14.4Q330.44,701,465.87,531.78C476.22,518.85,488.43,505,504,504.55c16.75-.44,30,14.86,40.91,29.05,29.36,38.3,78.21,104.46,115.41,156.58,34.49-36.78,64.59-78.46,84-125.23-54.7-73.92-127-171.57-174.51-235.76-11.46-15.5-24.41-32-42.15-35.65-27.53-5.66-50.79,21.49-68.12,45.95L146.85,780.8C149.18,864.47,176.41,901.64,206.59,916.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M900.9,214.34c-31.43-62.82-84.51-109.62-142.57-141.16C672.6,26.61,573.5,10.78,479.6,29.56A415.14,415.14,0,0,0,347,81.43c-37.09,22.35-86.59,54.92-110.08,95a2.9,2.9,0,0,0,1.79,2.71c38.42-7.85,75.19-27.4,114.42-34.8s79.45-9.82,119.19-5.73c80.76,8.3,160.44,44.69,217.13,109.23s88,158.32,74.49,247.3A299.13,299.13,0,0,1,744.29,565c-19.39,46.77-49.49,88.45-84,125.23A691.08,691.08,0,0,1,607,741c-71.73,61.67-151.18,112.21-235.33,149.7-26.17,11.65-53.19,22.08-80.75,28.34v0s-28.42,11.32-60,5.77a55.81,55.81,0,0,1-24.27-7.95c-30.18-15.22-57.41-52.39-59.74-136.06l-29.29,41.35c-28.63,40.41-59,88-50.37,138.52,6.67,39.19,36.73,69.8,70.55,83s70.9,11.53,106.34,5.55c115.06-19.42,220.62-81.56,319.21-150.36,53.91-37.63,106.88-78,155.74-123.38,33.68-31.26,65.36-64.88,94-101.63,8.58-11,16.94-22.23,24.94-33.81l1.59-2.3c41-59.83,73.62-127.91,87.35-201.56C940.83,361.6,934.2,280.9,900.9,214.34Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1100,1067.2,813.05,673.86c-28.66,36.75-60.34,70.37-94,101.63L925.62,1067.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealmLogoNoText);
export default __webpack_public_path__ + "static/media/realm-logo-no-text.c2f18b944ee52e45a566a712623e0bf3.svg";
export { ForwardRef as ReactComponent };